import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import PlanFeatures from "src/features/account/pricingPlans/features/PlanFeatures";
import React from "react";
const FreePlanFeatures = () => {
    const { t } = useTranslation();
    const FREE_FEATURES = [
        { text: t("infos:free.plan.1_"), tooltip: undefined },
        { text: t("infos:free.plan.2_"), tooltip: undefined },
        { text: t("infos:free.plan.3_"), tooltip: t("infos:free.plan.3.tooltip_") },
        { text: t("infos:free.plan.4_"), tooltip: undefined },
    ];
    return _jsx(PlanFeatures, { features: FREE_FEATURES });
};
export default FreePlanFeatures;
